export const TIME_FORMAT = "MM/dd/yyyy HH:mm";
export const ONE_MINUTE = 60 * 1000;
export const FIVE_SECONDS = 5 * 1000;
